module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_25.55108d70.jpg";